import type * as Types from '../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type GetAllCertificatesOfStudyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllCertificatesOfStudyQuery = { allCertificatesOfStudy?: Types.Maybe<{ __typename?: 'DownloadFile', fileName?: Types.Maybe<string>, downloadUri?: Types.Maybe<string> }> };


export const GetAllCertificatesOfStudyDocument = gql`
    query getAllCertificatesOfStudy {
  allCertificatesOfStudy {
    fileName
    downloadUri
  }
}
    `;

/**
 * __useGetAllCertificatesOfStudyQuery__
 *
 * To run a query within a React component, call `useGetAllCertificatesOfStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCertificatesOfStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCertificatesOfStudyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCertificatesOfStudyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllCertificatesOfStudyQuery, GetAllCertificatesOfStudyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllCertificatesOfStudyQuery, GetAllCertificatesOfStudyQueryVariables>(GetAllCertificatesOfStudyDocument, baseOptions);
      }
export function useGetAllCertificatesOfStudyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllCertificatesOfStudyQuery, GetAllCertificatesOfStudyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllCertificatesOfStudyQuery, GetAllCertificatesOfStudyQueryVariables>(GetAllCertificatesOfStudyDocument, baseOptions);
        }
export type GetAllCertificatesOfStudyQueryHookResult = ReturnType<typeof useGetAllCertificatesOfStudyQuery>;
export type GetAllCertificatesOfStudyLazyQueryHookResult = ReturnType<typeof useGetAllCertificatesOfStudyLazyQuery>;
export type GetAllCertificatesOfStudyQueryResult = ApolloReactCommon.QueryResult<GetAllCertificatesOfStudyQuery, GetAllCertificatesOfStudyQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
